import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/index.vue'
import Thank from '../views/thank-you.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/thank-you/',
    name: 'Thank',
    component: Thank
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router